export const getJackpot = ({
    amount = 0,
    step,
    currency,
    hitTime = null,
    betDependent = false
}) => ({
    currencyCode: currency,
    step: Number(step) || 0.01,
    amount: amount * 0.99,
    originAmount: amount,
    hitTime,
    betDependent
});

export const parseJackpots = (gameData = {}, currencyCode) => {
    const jackpots = {};

    for (const [code, data] of Object.entries(gameData)) {
        const {
            highestAmount: {
                [currencyCode]: amount
            } = {},
            highestGuaranteedHitTime,
            betDependent = false
        } = data || {};

        jackpots[code] = getJackpot({
            amount,
            betDependent,
            step: 0,
            currency: currencyCode,
            hitTime: highestGuaranteedHitTime && new Date(highestGuaranteedHitTime).getTime()
        });
    }

    return jackpots;
};

export const parseCasinoJackpot = (json, currencyCode) => {
    const {
        totalAmount: {
            [currencyCode]: amount
        } = {}
    } = json || {};

    return getJackpot({
        amount,
        step: 0,
        currency: currencyCode
    });
};

export const parseVFJackpots = (vfJackpots = []) => vfJackpots.reduce((memo, {
    jackpotName: gameCode,
    jackpotAmount: amount,
    Step: step,
    currency: currency
}) => {
    memo[gameCode] = getJackpot({
        amount,
        step,
        currency
    });

    return memo;
}, {});
